import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Typewriter from 'typewriter-effect'
import PixelImage from '../PixelImage'
import '../../styles/shared.css'

const IntroSection = ({
  title,
  titleLink = '/',
  backgroundImage,
  typewriterStrings = [],
  children,
  className = ''
}) => {
  return (
    <div className={`intro_sec d-block d-lg-flex align-items-center ${className}`}>
      <PixelImage
        src={backgroundImage}
        className='h_bg-image order-1 order-lg-2 h-100'
      />
      <div className='text order-2 order-lg-1 h-100 d-lg-flex justify-content-center'>
        <div className='intro mx-auto'>
          <Link to={titleLink} className='title mb-1x'>
            {title}
          </Link>
          {typewriterStrings.length > 0 && (
            <div className='mb-1x'>
              <Typewriter
                options={{
                  strings: typewriterStrings,
                  autoStart: true,
                  loop: true,
                  deleteSpeed: 10,
                }}
              />
            </div>
          )}
          <div className='d-flex'>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

IntroSection.propTypes = {
  title: PropTypes.string.isRequired,
  titleLink: PropTypes.string,
  backgroundImage: PropTypes.string.isRequired,
  typewriterStrings: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  className: PropTypes.string
}

export default IntroSection